/* eslint-disable no-await-in-loop */
import { CALL_INTERNAL_API } from '../../middleware/authHeaders'
import { INTERNAL_API_ROOT } from '../../config/api'
import { successNotification, errorNotification } from '../application/notifications'

// TYPES AND ACTIONS
export const GET_LABELS_DETAILS_REQUEST = 'GET_LABELS_DETAILS_REQUEST'
export const GET_LABELS_DETAILS_SUCCESS = 'GET_LABELS_DETAILS_SUCCESS'
export const GET_LABELS_DETAILS_FAILURE = 'GET_LABELS_DETAILS_FAILURE'

export const clearLabelItems = () => ({
  type: GET_LABELS_DETAILS_REQUEST,
})

export const getLabelDetails = orgId => async dispatch => {
  const continuationToken = ''
  const allItems = []
  const fetchPage = async token => {
    const query = token ? `?&continuationToken=${token}` : ''
    const response = await dispatch({
      [CALL_INTERNAL_API]: {
        endpoint: `${INTERNAL_API_ROOT}/admin/organizations/${orgId}/labels/${query}`,
        method: 'GET',
        types: [
          GET_LABELS_DETAILS_REQUEST,
          {
            type: GET_LABELS_DETAILS_SUCCESS,
            payload: async (action, state, res) => {
              const data = await res.json()
              return {
                items: data.items,
                continuationToken: data.continuationToken,
              }
            },
          },
          GET_LABELS_DETAILS_FAILURE,
        ],
      },
    })

    const { items, continuationToken: newToken } = response.payload
    allItems.push(...items)

    if (newToken) {
      await fetchPage(newToken) // recurse with new token
    } else {
      allItems.sort((a, b) => a.name.localeCompare(b.name))
      if (allItems.length === 0) {
        dispatch(
          successNotification({
            body: `No Labels found`,
            dismissInSeconds: 5,
          })
        )
      } else {
        dispatch({
          type: GET_LABELS_DETAILS_SUCCESS,
          payload: {
            items: allItems,
          },
        })
      }
    }
  }
  await fetchPage(continuationToken)
}
export const PUT_LABELS_DETAILS_REQUEST = 'PUT_LABELS_DETAILS_REQUEST'
export const PUT_LABELS_DETAILS_SUCCESS = 'PUT_LABELS_DETAILS_SUCCESS'
export const PUT_LABELS_DETAILS_FAILURE = 'PUT_LABELS_DETAILS_FAILURE'

export const UpdateLabelAssignmentDetails = details => dispatch => {
  const { labelName, ...requestBody } = details
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'PUT',
      endpoint: `${INTERNAL_API_ROOT}/admin/submissions/labels`,
      types: [PUT_LABELS_DETAILS_REQUEST, PUT_LABELS_DETAILS_SUCCESS, PUT_LABELS_DETAILS_FAILURE],
      body: JSON.stringify(requestBody),
    },
  }).then(response => {
    if (response.error) {
      const orgIdInfo = requestBody.LegacyOrganizationId
        ? ` (Org ID entered: ${requestBody.LegacyOrganizationId})`
        : ''
      const customErrorMessage =
        response?.payload?.response?.messages?.length > 0
          ? `${response.payload.response.messages[0]}${orgIdInfo}`
          : `Error updating labels to submission id's`
      dispatch(
        errorNotification({
          body: customErrorMessage,
          dismissInSeconds: 8,
        })
      )
    } else {
      dispatch(
        successNotification({
          body: `Label ${labelName} updated successfully for ${requestBody.submissionIds.length} submissions`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

// INITIAL STATE
const INITIAL_STATE = {
  labelData: {
    items: [],
    isLoading: false,
    error: false,
  },
}
// REDUCER
const lookUpBatchLabels = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_LABELS_DETAILS_REQUEST]: currentState => ({
      ...currentState,
      labelData: {
        isLoading: true,
        error: false,
      },
    }),
    [GET_LABELS_DETAILS_FAILURE]: currentState => ({
      ...currentState,
      labelData: {
        isLoading: false,
        error: true,
      },
    }),
    [GET_LABELS_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
      labelData: {
        items: [...newPayload.items],
        isLoading: false,
        error: false,
      },
    }),
    [PUT_LABELS_DETAILS_REQUEST]: currentState => ({
      ...currentState,
      labelData: {
        ...currentState.labelData,
        isLoading: true,
        error: false,
      },
    }),
    [PUT_LABELS_DETAILS_FAILURE]: currentState => ({
      ...currentState,
      labelData: {
        ...currentState.labelData,
        isLoading: false,
        error: true,
      },
    }),
    [PUT_LABELS_DETAILS_SUCCESS]: currentState => ({
      ...currentState,
      labelData: {
        ...currentState.labelData,
        isLoading: false,
        error: false,
      },
    }),
  }[type]?.(state, payload) || state)
export default lookUpBatchLabels

// SELECTORS
export const selectLookUpBatchLabels = state => state.lookUp.lookUpBatchLabels
export const selectLabelData = state => selectLookUpBatchLabels(state).labelData.items
export const isApplying = state => selectLookUpBatchLabels(state).labelData.isLoading
